import axios from 'axios';
import {
  debounce
} from 'debounce';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

class Carousel {
  constructor(options) {

    var defaults = {
      itemsToScroll: 3,
      paginationUrl: null,
      paginationEnd: 3,
      eventPrefix: ''
    };

    this.params = Object.assign({}, defaults, options || {});
    this.container = document.querySelector(this.params.selector);
    this.carousel = this.container.querySelector('.roll');
    this.carouselItemsContainer = this.container.querySelector('.roll-items');
    this.carouselItems = this.container.querySelectorAll('.roll-item');
    this.navigationButtons = this.container.querySelectorAll('.roll-navigation-button');
    this.previousButton = this.container.querySelector('.roll-previous');
    this.previousButton.disabled = true;
    this.nextButton = this.container.querySelector('.roll-next');

    this.paginating = false;
    this.maxPages = this.params.paginationEnd;
    this.page = 1;

    this.addEvents();
  }

  addEvents() {
    for (var index = 0; index < this.navigationButtons.length; index++) {
      this.addNavigationButtonEvent(index);
    }
    if (this.previousButton) {
      this.previousButton.addEventListener('click', (event) => this.navigate(event, 'previous'));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (event) => this.navigate(event, 'next'));
    }
    if (this.previousButton || this.nextButton) {
      this.carouselItemsContainer.addEventListener('scroll', debounce((event) => this.onScroll(event), 50), this.isIE() ? false : {
        passive: true
      });
    }

    this.carouselItemsContainer.addEventListener('refresh', (e) => {
      this.refresh();
      this.carouselItemsContainer.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, false);

  }

  addNavigationButtonEvent(index) {
    this.navigationButtons[index].addEventListener('click', (event) => this.navigateTo(event, index));
  }

  onScroll() {
    this.previousButton.disabled = this.carouselItemsContainer.scrollLeft <= 0;
    var endOffset = this.carouselItemsContainer.scrollWidth - this.carouselItemsContainer.clientWidth;
    this.nextButton.disabled = this.carouselItemsContainer.scrollLeft >= endOffset;
    var paginationOffset = endOffset - 800;
    if (this.params.paginationUrl && !this.paginating && this.page <= this.maxPages && this.carouselItemsContainer.scrollLeft >= paginationOffset) {
      this.nextButton.disabled = false;
      this.paginate();
    }

    // Detect first visible item
    let trackLeft = this.carouselItemsContainer.getBoundingClientRect().left;
    let firstVisibleIndex = Array.from(this.carouselItems).findIndex(function (el) {
      return el.getBoundingClientRect().left >= trackLeft - 1;
    });

    // Dispatch event
    const eventName = this.params.eventPrefix + 'carousel-scrolled';
    const event = new CustomEvent(eventName, { detail: { index: firstVisibleIndex } });
    window.dispatchEvent(event);

  }

  paginate() {
    this.paginating = true;
    this.carousel.classList.add('paginating');
    this.page++;
    axios.get(this.params.paginationUrl + '&page=' + this.page).then((response) => {
      var div = document.createElement('div');
      div.innerHTML = response.data;
      div.classList.add('roll-items-group');
      this.carouselItemsContainer.appendChild(div);
      this.refresh();
      this.carousel.classList.remove('paginating');
      this.paginating = false;
    });
  }


  refresh() {
    this.carouselItems = this.container.querySelectorAll('.roll-item');
  }

  navigate(event, direction) {
    var pixels = this.params.itemsToScroll * this.getFirstItemWidth();
    if (direction === 'previous') {
      pixels = -pixels;
    }
    this.navigateBy(event, pixels);
  }

  navigateTo(event, index) {
    event.preventDefault();
    var pixels = index * this.getFirstItemWidth();
    this.carouselItemsContainer.scroll({
      top: 0,
      left: pixels,
      behavior: 'smooth'
    });
  }


  navigateBy(event, pixels) {
    event.preventDefault();
    this.carouselItemsContainer.scrollBy({
      top: 0,
      left: pixels,
      behavior: 'smooth'
    });
  }

  getFirstItemWidth() {
    var style = window.getComputedStyle(this.carouselItems[0]);
    var width = parseInt(style.width) + parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
  }

  isIE() {
    return window.navigator.userAgent.indexOf('MSIE ') !== -1;
  }
}

export {
  Carousel as
    default
};
